import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
	name: 'meters',
	standalone: true,
})
export class MetersPipe implements PipeTransform {
	transform(value: number | string, ...args: unknown[]): number | string {
		if (typeof value === 'string' && isNaN(Number(value))) {
			return value // Si no es un número válido, devuelve el valor original
		}

		const meters = Number(value)

		if (meters >= 1000) {
			return `${(meters / 1000).toFixed(2)}km`
		} else {
			return `${meters}m`
		}
	}
}
